import { Injectable, NgZone } from '@angular/core';
import * as firebase from 'firebase';
import { User } from '../models/User';
import { BehaviorSubject, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { isNullOrUndefined } from 'util';
import { Roles } from '../models/Roles';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  uid: string;
  currentUserSignedIn: firebase.User;
  private currentUser = new BehaviorSubject(null);
  user = this.currentUser.asObservable();
  drawerOpenO: Subject<boolean> = new Subject();
  errorAuth: Subject<string> = new Subject();
  constructor(public ng: NgZone, public router: Router, public snackBar: MatSnackBar) {
    this.observeUser();
  }

  createClientAndSendPasswordResetEmail(email: string, pass: string, user: User, companyName: string) {
    const cu = firebase.auth().currentUser
    firebase.auth().createUserWithEmailAndPassword(email, pass).then((response) => {
      firebase.auth().sendPasswordResetEmail(email).then((responseemail) => {
        user.uid = response.user.uid;
        this.writeUserToDB(user, companyName, null, () => {
          firebase.auth().updateCurrentUser(cu)
        });
        this.snackBar.open('Owner Created!', null, {
          duration: 5000,
        });
      }).catch((error) => {
        this.errorAuth.next(error.message);
      });
    }).catch((error) => {
      this.errorAuth.next(error.message);
    });
  }

  writeUserToDB(user: User, companyName: string = 'N/A', createdBy: string = 'N/A', action: Function = null) {
    const db = firebase.firestore();
    db.collection('users').add({
      name: user.name,
      email: user.email,
      role: user.role,
      uid: user.uid,
      companyName: companyName,
      createdBy: createdBy
    }).then((document) => {
      if (action)
        action()
      else
        this.determineRoute(user.role);
    }).catch((error) => {
      console.log(error);
    });
  }

  determineRoute(role: any) {
    this.ng.run(() => this.router.navigateByUrl('home')).then(() => {
      location.reload();
    });
  }

  passwordForgetEmail(email: string) {
    firebase.auth().sendPasswordResetEmail(email).then((response) => {
      this.snackBar.open('Password reset email sent!', null, {
        duration: 5000,
      });
    }).catch((error) => {
      this.errorAuth.next(error.message);
    });
  }

  login(email: string, password: string) {
    firebase.auth().signInWithEmailAndPassword(email, password)
      .then((data) => {
        this.snackBar.open('Logged In', null, {
          duration: 5000,
        });
        this.drawerOpen(true);
        this.errorAuth.next('');
      }).catch((error) => {
        // this.snackBar.open('Email and/or password incorrect', null, {
        //   duration: 5000,
        // });
        this.errorAuth.next('Email and/or password incorrect');
      });
  }

  createPatient(fname: string, lname: string, patientId: string, legalCaseId: string, dob: string) {
    const db = firebase.firestore();
    db.collection('patients').doc(patientId).set({
      FirstName: fname,
      LastName: lname,
      caseName: patientId,
      LegalCaseId: legalCaseId,
      DateOfBirth: dob,
      uidOfCreator: firebase.auth().currentUser.uid,
      files: [],
      fileSearchQuery: [],
      sharedWith: []
    }).then((result) => {
      this.snackBar.open('Client Added', null, { //Patient added
        duration: 5000,
      });
      this.errorAuth.next('');
    }).catch((error) => {
      this.errorAuth.next('Error Creating Client'); //Patient added
    });
  }

  createUserAndSendPasswordResetEmail(password: string, user: User, createdBy: string) {
    const cu = firebase.auth().currentUser
    firebase.auth().createUserWithEmailAndPassword(user.email, password).then((response) => {
      firebase.auth().sendPasswordResetEmail(user.email).then((resp) => {
        user.uid = response.user.uid;
        this.snackBar.open(user.role + ' Created', null, {
          duration: 5000,
        });
        this.writeUserToDB(user, 'N/A', createdBy, () => {
          firebase.auth().updateCurrentUser(cu)
        });
        this.errorAuth.next('');
      }).catch((error) => {
        this.errorAuth.next('Error Creating User');
      });
    }).catch((error) => {
      this.errorAuth.next('Error Creating User');
    });
  }

  observeUser() {
    firebase.auth().onAuthStateChanged((user) => {
      try {
        this.uid = user.uid;
        this.currentUser.next(user);
      } catch (e) {
      }
    });
  }

  logout() {
    firebase.auth().signOut().then(() => {
      this.currentUser.next(null);
      this.ng.run(() => this.router.navigateByUrl('/'));
      this.drawerOpen(false);
    }).catch((error) => {
      this.snackBar.open(error.message, null, {
        duration: 5000,
      });
    });
  }

  drawerOpen(bool: boolean) {
    this.drawerOpenO.next(bool);
  }
  firePatientCantAdd() {
    this.errorAuth.next('Fill In the required fields');
  }

  getUid() {
    const user: firebase.User = firebase.auth().currentUser;
    if (isNullOrUndefined(user)) { return ''; }
    return firebase.auth().currentUser.uid;
  }
}
